import React, { useCallback, useMemo } from 'react';
import ItemContent from '../../../../components/ItemContent/ItemContent';
import useDescLangs from '../../../../utils/useDescLangs';
import { useTranslation } from 'react-i18next';
import { NSAppVersions } from '../../../../types/interfaces/NSAppVersions';
import { IEditForm } from '../../../../types/interfaces/IEditForm';
import tPaths from '../../../../utils/tPaths';
import { endpoints } from '../../../../utils/endpoints';
import { EPaths } from '../../../../types/enums/EPaths';
import { CircularProgress } from '@material-ui/core';
import { collectTypes, fieldsOfALanguage } from '../../../../utils/js';
import CustomLabel from '../../../../components/LabelWithPars/components/CustomLabel';

const AppVersions = ({ editable }: { editable: boolean }) => {
  const { languagesList, reduceLangsList } = useDescLangs();
  const { t } = useTranslation();

  const descriptionMapper = useCallback(
    (data: NSAppVersions.IData, key: string): IEditForm[][] => {
      const items: IEditForm[][] = data.appVersions.map((item) => [
        {
          type: 'title',
          label: item._id,
          fieldName: item._id,
        },
        {
          type: 'input',
          fieldName: item._id + ':android',
          label: <CustomLabel label={t(tPaths.editFormLabels.android)} />,
          initialValue: item.android,
        },
        {
          type: 'input',
          fieldName: item._id + ':ios',
          label: <CustomLabel label={t(tPaths.editFormLabels.ios)} />,
          initialValue: item.ios,
        },
      ]);
      return items;
    },
    [t],
  );

  const tabs = useMemo(
    () => [...languagesList.map((lang) => ({ key: lang.key, label: lang.display }))],
    [languagesList],
  );

  const tabsContentMapper = useCallback(
    (data: NSAppVersions.IData) => ({
      ...languagesList.reduce(
        (acc, cv) => ({
          ...acc,
          [cv.key]: descriptionMapper(data, cv.key),
        }),
        {},
      ),
    }),
    [descriptionMapper, languagesList],
  );

  const updateDataFormatter = useCallback(
    (fields: any) => ({
      appVersions: collectTypes(fields).map((appVersionType: any) => ({
        _id: appVersionType,
        android: fieldsOfALanguage(fields)[appVersionType + ':android'].value,
        ios: fieldsOfALanguage(fields)[appVersionType + ':ios'].value,
      })),
    }),
    [reduceLangsList],
  );

  return (
    <>
      {languagesList.length ? (
        <ItemContent
          path={EPaths.LegalLinks}
          title={t(tPaths.itemContent.editAppVersions)}
          tabs={tabs}
          tabsContentMapper={tabsContentMapper}
          updateDataFormatter={updateDataFormatter}
          apiUrl={endpoints.appVersions}
          backButton={false}
          editable={editable}
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default AppVersions;
